
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "IdentificationofRaynaudDiseaseandRaynaudPhenomenon",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/IdentificationofRaynaudDiseaseandRaynaudPhenomenon.vue